@if (accountService.hasAccessScope('download-report') | async) {
  <a class="nav-link" (click)="downloadReport()" id="nav-download-report">
    <div class="icon-container">
      <img src="/assets/images/menu/ICN_Line_Download.svg"/>
    </div>
    Download Full Credit Report
  </a>
  <hr />
}
